var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _g, _g2, _circle15, _circle16, _g3, _circle17, _circle18, _circle19, _circle20, _g4, _circle21, _circle22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefits5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 67,
    viewBox: "0 0 64 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 9.5,
    r: 5,
    fill: "#52EF94"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 21.5,
    r: 5,
    fill: "#52EF94"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 21.5,
    r: 5,
    fill: "#52EF94"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 33.5,
    r: 5,
    fill: "#54D9BC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 9.5,
    r: 4,
    fill: "#52EF94"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 9.5,
    r: 4,
    fill: "#52EF94"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 33.5,
    r: 4,
    fill: "#54D9BC"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 45.5,
    r: 4,
    fill: "#41D4C3"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 45.5,
    r: 4,
    fill: "#41D4C3"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 21.5,
    r: 4,
    fill: "#52EF94"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 45.5,
    r: 3,
    fill: "#41D4C3"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 57.5,
    r: 2,
    fill: "#2EC8CA"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 45.5,
    r: 2,
    fill: "#41D4C3"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 33.5,
    r: 2,
    fill: "#54D9BC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2706_3152)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 45.5,
    r: 2,
    fill: "#2EB7CA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2706_3152)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 33.5,
    r: 2,
    fill: "#2EB7CA"
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 57.5,
    r: 2,
    fill: "#2EC8CA"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 57.5,
    r: 2,
    fill: "#2EC8CA"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2706_3152)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57.5,
    r: 1,
    fill: "#2EB7CA"
  }))), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 57.5,
    r: 1,
    fill: "#2EC8CA"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9.5,
    r: 1,
    fill: "#52EF94"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 9.5,
    r: 1,
    fill: "#52EF94"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 9.5,
    r: 1,
    fill: "#52EF94"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2706_3152)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 21.5,
    r: 1,
    fill: "#2EB7CA"
  }))), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 21.5,
    r: 1,
    fill: "#52EF94"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 33.5,
    r: 1,
    fill: "#54D9BC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2706_3152",
    x: 51,
    y: 43.5,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2706_3152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2706_3152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2706_3152",
    x: 51,
    y: 31.5,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2706_3152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2706_3152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2706_3152",
    x: 52,
    y: 56.5,
    width: 10,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2706_3152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2706_3152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2706_3152",
    x: 52,
    y: 20.5,
    width: 10,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2706_3152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2706_3152",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits5);
export default __webpack_public_path__ + "static/media/benefits-5.228f8e5f93cd6b08062d0b670a9d8c56.svg";
export { ForwardRef as ReactComponent };